import { Box, Button } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { WidgetComponentMaps } from "../../../common/WidgetComponentMaps";
import { filledButton } from "../../../ui/styles/buttonStyles";
import VaultContent from "../../component/principals/VaultContent";

export const VaultWidget = ({ swapyName = "vaultWidget", sx }) => {
    return (
        <WidgetComponentMaps
            swapyName={swapyName}
            title="Organization Vault"
            description="Securely store and organize passwords, access credentials, recovery details, and two-factor authentication information for your organization."
            icon={<LockOutlined />}
            sxProp={{
                ...sx,
                height: { xs: "400px", md: "450px", lg: "100%" },
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box sx={{ flex: 1 }} />

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "end",
                    bgcolor: "transparent",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                    }}
                >
                    <BaseModalComponent
                        modalKey="Organization-Vault"
                        modalLabel="Manage Vault"
                        elementTrigger={
                            <Button sx={filledButton}>Manage vault</Button>
                        }
                    >
                        <VaultContent />
                    </BaseModalComponent>
                </Box>
            </Box>
        </WidgetComponentMaps>
    );
};